import { useState } from 'react'

import type { GeblokkeerdeWeek } from '../../../../planning/types/GeblokkeerdeWeek'
import type { ProcesstapHoofdleiding } from '../../../../status/types/ProcesstapHoofdleiding'
import type { HoofdleidingProject } from '../../../project/types/HoofdleidingProject'
import type { OptionsDialogData } from '../../types/OptionsDialogData'

import { ProjectOptionsDialog } from './ProjectOptionsDialog'
import { ProjectOptionsMenu } from './ProjectOptionsMenu'

type Props = {
  project: HoofdleidingProject
  anchorEl?: HTMLElement
  setAnchorEl: (anchor?: HTMLElement) => void
  showHoofdleidingOptions?: boolean
  processtappen: ProcesstapHoofdleiding[]
  geblokkeerdeWeken: GeblokkeerdeWeek[]
  selectableLabels: string[]
}

export const ProjectOptions = ({
  project,
  anchorEl,
  setAnchorEl,
  processtappen,
  geblokkeerdeWeken,
  selectableLabels,
}: Props) => {
  const [type, setType] = useState<OptionsDialogData['type']>()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const onOpenDialog = (data: OptionsDialogData) => {
    setIsDialogOpen(true)
    setType(data.type)
  }

  return (
    <>
      <ProjectOptionsMenu
        project={project}
        onClose={() => setAnchorEl(undefined)}
        anchorEl={anchorEl}
        onOpenDialog={onOpenDialog}
        selectableLabels={selectableLabels}
      />
      <ProjectOptionsDialog
        open={isDialogOpen}
        project={project}
        type={type}
        onClose={() => setIsDialogOpen(false)}
        processtappen={processtappen}
        geblokkeerdeWeken={geblokkeerdeWeken}
        selectableLabels={selectableLabels}
      />
    </>
  )
}
